import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

import { EventOptionGroup, EventParticipantImage } from '@frontend/sports/betting-offer/feature/model';
import { NumberDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { CouponTypes } from '@frontend/sports/coupons/feature/models';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { TrackingSource } from '@frontend/sports/tracking/feature';

import { SourceOfPick } from '../betslip-base/models/pick-models';
import { OptionComponent } from '../option-group/option.component';

@Component({
    selector: 'ms-grid-option-group',
    templateUrl: 'grid-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ParticipantImageComponent, OptionComponent],
})
export class GridOptionGroupComponent implements OnChanges {
    @Input() activeEvent: GridEvent;
    @Input() activeOptionGroup: EventOptionGroup;
    @Input() showParticipantImage?: boolean;
    @Input() enableOptionImages: boolean;
    @Input() optionImages: NumberDictionary<EventParticipantImage> = {};
    @Input() tracking: TrackingSource;
    @Input() betDetails? = '';
    @Input() sourceOfPick: SourceOfPick;
    @Input() couponType?: CouponTypes;
    @Input() showBottomBorder: true;
    @Input() lastRowOptionsCount = 0;
    @Input() isOutrightGrid = false;
    @Input() threshold?: number;

    activeGroup: EventOptionGroup;

    @HostBinding('class') className = 'grid-options';

    ngOnChanges(changes: SimpleChanges): void {
        const group = changes?.activeOptionGroup;
        if (group) {
            this.activeGroup = this.activeOptionGroup;
        }
    }

    showOption(index: number): boolean {
        return index < this.threshold!;
    }

    getTracking(index: number): { source: string; position: number } {
        return { source: this.tracking.source, position: index };
    }

    hasParticipantImage(index: number): boolean {
        return this.enableOptionImages && this.couponType ? this.showParticipantImage! : this.showOption(index);
    }
}
